import styled from 'styled-components';
import conectadosBackground from '../../../assets/conectados/conectados_background.png';

const BackgroundWrapper = styled.div`
  min-height: calc(100vh - 90px);
  background: url(${conectadosBackground}) center center;
  background-size: cover;
  background-attachment: fixed;
  position: relative;
  overflow-x: hidden;
  
  /* Subtle overlay for better readability */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.15);
    z-index: 1;
  }

  @media (max-width: 768px) {
    min-height: calc(100vh - 75px);
  }
`;

export default BackgroundWrapper;

